import {
    openChildWindow,
    sendToAllChildWindows,
    closeAllChildWindows
} from './../utilities/windowManager';
import { DOMAINCLIENT } from "../Constant.js";

export const useWindowManager = () => {
    const redirectToTagging = (profile_id, task_mediatype, taggerId, auth) => {
        const origin = DOMAINCLIENT;
        console.log("origin >>>", origin)
        const url = `${DOMAINCLIENT}/${profile_id}/${task_mediatype}?roleid=${auth.profile_role}&username=${taggerId}`;

        let receiverWindow;

        const handleChildReady = (event) => {
            if (event.origin === origin && event.data.type === "CHILD_READY") {
                window.removeEventListener("message", handleChildReady);
                if (receiverWindow && !receiverWindow.closed) {
                    receiverWindow.postMessage(
                        { type: "SHARE_TOKEN", token: localStorage.getItem('token') },
                        origin
                    );
                }
            }
        };

        window.addEventListener("message", handleChildReady);

        receiverWindow = openChildWindow(url);

        return receiverWindow;
    };

    const logout = () => {
        const origin = DOMAINCLIENT;
        localStorage.removeItem('token');
        sendToAllChildWindows({ type: "LOGOUT" }, origin);
        closeAllChildWindows();
    };

    return { redirectToTagging, logout };
};